import React from "react";
import 'react-responsive-modal/styles.css';
import "./style.css";
import projects from "../../constants/projects";

function Renders() {

  return <div>

    {projects.map((p, i) => {
      return (
        <div
          key={p.id}
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: "20dvh",
            width: "100%",
            margin: "15px",
            justifyContent: "space-evenly",
            marginLeft: "0",
          }}
        >
          <div   style={{
            width: i % 2 === 0 ? "68%" : "30%",
            borderRadius: "5px",
            overflow: 'hidden'
          }}>
            <img
              alt="render"
              className="render"
              onClick={() => window.location.assign(`/project/${p.id}`)} 
              style={{width: '100%', height: '100%', overflow: 'hidden'}}
              src={i % 2 === 0 ? p.horizontalImage : p.verticalImage}
            />
            <label style={{backgroundColor: 'pink'}}>teste</label>
          </div>
          <div style={{
            width: i % 2 !== 0 ? "68%" : "30%",
            borderRadius: "5px",
            overflow:'hidden'
          }}>
            <img
              style={{width: '100%', height: '100%', overflow: 'hidden'}}
              alt="render"
              onClick={() => window.location.assign(`/project/${p.id}`)} 
              className="render"
              src={i % 2 !== 0 ? p.horizontalImage : p.verticalImage}
            />
          </div>
        </div>
      )})
    }
  </div>
    
  
}

export default Renders;
